import Service from "../../Service";
 
const resource = "PrfInductors/";

export default {
    save(cmp, requestID) {
        return Service.post(resource + "save", cmp, {
            params: { requestID: requestID },
        });
    },

    pagination(parameters, requestID) {
        return Service.post(resource + "pagination", parameters, {
            params: { requestID: requestID },
        });
    },
    list( requestID) {
        return Service.post(resource + "list", {}, {
            params: { requestID: requestID },
        });
    },
    InductorServiceLayer(arts, UsrID, requestID) {
        return Service.post(resource + "InductorServiceLayer", arts, {
        params: { UssUserID: UsrID, requestID },
        });
    },
    getListMaterials(parameters,requestID) {
        return Service.post(resource + "listMaterial", parameters, {
            params: { requestID: requestID },
        });
    },
    ListMaterialsServiceLayer(ListMat, UsrID, requestID) {
        return Service.post(resource + "ListMaterialServiceLayer", ListMat, {
        params: { UssUserID: UsrID, requestID },
        });
    },     

};